import localStorageService from '../../services/localStorageService';

import { LOAD_BRAND } from '../actions/BrandActions';

const savedState = localStorageService.getItem('brandReducer');

const initialState = {
  loaded: false,
  data: savedState
};

const brandReducer = function (state = initialState, action) {
  switch (action.type) {
    case LOAD_BRAND: {
      localStorageService.setItem('brandReducer', action.payload);
      return { loaded: true, data: action.payload };
    }
    default:
      return state;
  }
};

export default brandReducer;
